import $ from 'jquery';

$('.teaser__image-description-wrap').on('click', function () {
    $(this).toggleClass('teaser__image-description-wrap--open');
    $(this).siblings('.teaser__image-description-wrap').removeClass('teaser__image-description-wrap--open');
})
